export const ROUTE_PATH_DECKS = "/decks";
export const ROUTE_PATH_ID_FROM_PARAM = `${ROUTE_PATH_DECKS}/single`;
